import type { FormInstance } from 'antd'
import { Form } from 'antd'
import React, { useMemo, useState } from 'react'
import { FileText, Play, Trash } from '@yy/one-icon'
import { OneButton, OneCheckbox, OneInput } from '@yy/one-ui'
import Container, { storeUtil } from '../../../Context'
import { useSubmit, useTranslation } from '../../../hooks'
import ReplayModal from '../../ReplayModal/'
import Rule from '../../Rules'
import RecordButton from '../RecordButton'
import styles from './index.module.less'
import Policy from './Policy'

const showTime = (time?: string | number) => {
  if (!time) return ''

  const date = new Date(time)
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const second = date.getSeconds()

  const fillZero = (number) => (number.toString().length >= 2 ? number : `0${number}`)

  const timeStr = `${year}/${fillZero(month)}/${fillZero(day)} ${fillZero(hours)}:${fillZero(minutes)}:${fillZero(second)}`

  return timeStr
}

type IReportForm = {
  form?: FormInstance
}

const PolicyCheckbox = (props) => {
  return (
    <div className={styles.policyWrap}>
      <OneCheckbox {...props}></OneCheckbox>
      <Policy />
    </div>
  )
}

const ReportForm: React.FC<IReportForm> = ({ form }) => {
  const { setVisible, events, setRecordToolVisible, setEvents, config, reset, startRecord, type, time } = Container.useContainer()
  const [recordVisible, setRecordVisible] = useState(false)
  const { t } = useTranslation()

  const handleShowRecordTool = () => {
    setVisible(false)
    setRecordToolVisible(true)
    startRecord()
  }

  const handleReplay = () => {
    setRecordVisible(true)
  }

  const { submit, loading } = useSubmit()

  const descPlaceHolder = useMemo(() => {
    return type === 'bug' ? t('feedback.desc.error.tips') : t('feedback.desc.advise.tips')
  }, [t, type])

  return (
    <>
      <div className={styles.formWrap}>
        <Form
          form={form}
          initialValues={{
            agree: storeUtil.get().checkbox,
          }}
        >
          <Form.Item name="email" rules={Rule.email} initialValue={config.current?.email}>
            <OneInput size="large" placeholder={t('feedback.form.email')} type="email" />
          </Form.Item>

          <Form.Item name="description" rules={Rule.description}>
            <OneInput.TextArea placeholder={descPlaceHolder} />
          </Form.Item>

          <Form.Item className={styles.recordItem}>
            {events.length === 0 && (
              <>
                <div className={styles.recordTips}>{t('feedback.record.tips')}</div>
                <RecordButton onClick={handleShowRecordTool}></RecordButton>
              </>
            )}
            {events.length > 0 && (
              <div className={styles.replayItem}>
                <span className={styles.replayItemLeft}>
                  <FileText className={styles.fileIcon} />
                  <span>{showTime(time.record_start_time)}</span>
                </span>
                <span className={styles.replayItemLRight}>
                  <Play className={styles.playIcon} onClick={handleReplay} />
                  <Trash className={styles.deleteIcon} onClick={() => setEvents([])} />
                </span>
              </div>
            )}
          </Form.Item>

          <Form.Item name="agree" valuePropName="checked" rules={Rule.policyRule}>
            <PolicyCheckbox />
          </Form.Item>

          <Form.Item className={styles.submitItem}>
            <div className={styles.buttonWrap}>
              <OneButton onClick={reset} disabled={loading}>
                {t('feedback.cancel')}
              </OneButton>
              <OneButton type="primary" onClick={submit} loading={loading}>
                {t('feedback.submit')}
              </OneButton>
            </div>
          </Form.Item>
        </Form>

        {recordVisible && (
          <ReplayModal onCancel={() => setRecordVisible(false)}>
            <div id="rrplayer"></div>
          </ReplayModal>
        )}
      </div>
    </>
  )
}

export default ReportForm
